export default "__VITE_ASSET__J2TPEIr2__"